// ==============================|| OVERRIDES - INPUT BASE ||============================== //

import { Theme } from '@mui/material';

export default function InputBase(theme: Theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        sizeSmall: {
          fontSize: '0.75rem'
        },
        root: {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.background.default
          }
        }
      }
    }
  };
}
